import { observer } from 'mobx-react';
import { toast } from 'react-toastify';
import { useLaunchTinkerBoxMutation } from '../../api/mutations/launchTinkerBox';
import { HomeStore } from '../../stores/HomeStore';
import { TinkerBoxFileBrowser } from '../TinkerBoxFileBrowser';
import { PersonalModeHeader } from './PersonalModeHeader';
import { SidePanelShell } from './SidePanelShell';
import { TinkerBoxSection } from './TinkerBoxesSection';
interface UserSidePanelProps {
  className?: string;
  setOpen: (visible: boolean) => void;
  open: boolean;
  tinkerBoxConnection: HomeStore['tinkerBoxConnection'];
  store: HomeStore;
}
export const UserSidePanel = observer(
  ({
    store,
    open = true,
    setOpen,
    tinkerBoxConnection
  }: UserSidePanelProps) => {
    const { launchTinkerBox } = useLaunchTinkerBoxMutation();
    return (
      <SidePanelShell open={open} setOpen={setOpen}>
        {open && (
          <div className="p-4 pr-0 flex-col overflow-hidden h-full flex flex-1">
            <PersonalModeHeader />
            <div className="h-full flex flex-col overflow-hidden">
              <div
                className="files-panel w-full h-3/5 overflow-hidden flex-shrink-0"
                data-tour="storage"
              >
                <p className="pb-2">storage</p>
                {store.tinkerBoxId ? (
                  <TinkerBoxFileBrowser store={tinkerBoxConnection} />
                ) : (
                  <p className="py-1 italic">
                    Connect to a tinkerbox to view its files
                  </p>
                )}
              </div>
              <div className="tinkerbox-container overflow-hidden flex-grow flex flex-col pt-6">
                <div className="overflow-hidden h-full">
                  <TinkerBoxSection
                    hideIpAddress={true}
                    store={store}
                    mode="personal"
                    onLaunch={async () => {
                      const tbox = await launchTinkerBox();
                      toast.success(
                        `Tinker Box '${tbox.tinkerBox.name}' successfully launched`
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </SidePanelShell>
    );
  }
);
